module.exports = __webpack_public_path__ + "media/images/no_animation_preview-d278d315.png";